import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';
import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class AppointmentResource {
  private baseUri = '/prl/events';

  constructor(private ApiService: ApiService) {}

  // GET
  getAppointment(params: { appointmentId: string }): Observable<Docorga.interfaces.appointment.IAppointmentPrl> {
    return this.ApiService.get(`${this.baseUri}/${params.appointmentId}`);
  }

  findAppointments(params: {
    start: number;
    end: number;
    patientId: Docorga.interfaces.naturalTypes.NPatientObjectId | undefined;
  }): Observable<Array<Docorga.interfaces.appointment.IAppointmentPrl>> {
    return this.ApiService.get(`${this.baseUri}`, params);
  }

  // DELETE
  cancelAppointment(params: {
    appointmentId: Docorga.interfaces.naturalTypes.NEventObjectId;
  }): Observable<Array<Docorga.interfaces.event.IEventRecurrenceItemChange | null> | { error: string }> {
    return this.ApiService.post(`${this.baseUri}/${params.appointmentId}`);
  }
}
